import { useState } from 'react';
import publicResetPassword from '../api/publicResetPassword';

export default function useResetPassword(secret: string | undefined) {
    const [resettingInProcess, setResettingInProcess] = useState(false);
    const [resettingComplete, setResettingComplete] = useState<boolean | null>(null);
    const [wasResetPasswordUnsuccessful, setWasResetPasswordUnsuccessful] = useState<boolean>(false);
    const [serverErrorMessages, setServerErrorMessages] = useState<any>({});

    const reset = async (password: string) => {
        if (!secret) {
            setResettingComplete(false);
            setWasResetPasswordUnsuccessful(true);
            return;
        }

        setResettingComplete(null);
        setResettingInProcess(true);
        const response = await publicResetPassword(secret, password);

        if (response.status === 200) {
            setResettingComplete(true);
        } else if (Array.isArray(response)) {
            setResettingComplete(false);
            const errorsToDisplay = convertServerResponse(response);
            setServerErrorMessages(errorsToDisplay);
        } else {
            setResettingComplete(false);
            setWasResetPasswordUnsuccessful(true);
        }

        setResettingInProcess(false);
    };

    const convertServerResponse = (errorMessages: any[]) => {
        return errorMessages.reduce((acc, error) => {
            const errorKeys = Object.keys(error);
            const errorValues = Object.values(error);

            if (errorKeys.length) {
                if (!acc[errorKeys[0]]) {
                    acc[errorKeys[0]] = errorValues[0];
                }
            }
            return acc;
        }, {});
    };

    return {
        resettingInProcess,
        resettingComplete,
        reset,
        serverErrorMessages,
        wasResetPasswordUnsuccessful,
        setWasResetPasswordUnsuccessful
    };
}
